import { useMemo } from 'react';
import { useMatch } from 'react-router';

export function useOtherActionsPanelList() {
  const match = useMatch('/lists/:listId/*');

  return useMemo(() => {
    const otherActionList = [
      'Add to group(s)',
      'Remove from group(s)',
      'Add tag(s)',
      'Remove tag(s)',
      'Update Rocket status',
      'Update volunteer pathway',
      'Update campaign tasks',
    ];
    if (match?.params.listId) {
      otherActionList.push('Generate distribution list');
      otherActionList.push('Delete from list');
    }

    const ACCORDION_STARTING_STATE = Array(otherActionList.length).fill(false);

    return { otherActionList, ACCORDION_STARTING_STATE };
  }, [match?.params.listId]);
}
